import { motion } from "framer-motion";
import { ATHENA } from "@/constants/testIds";

const METRICS = [
  { slug: "domains", n: "05", l: "Domains of scientific expertise" },
  { slug: "extracts", n: "40+", l: "Standardised bioactive extracts" },
  { slug: "formulations", n: "24", l: "Custom formulations in development" },
  { slug: "bioavailability", n: "3×", l: "Average bioavailability uplift" },
  { slug: "traceability", n: "100%", l: "Traceable batch-level chain of custody" },
  { slug: "compliance", n: "ISO+GMP", l: "Compliant across every SKU" },
];

export const Why = () => {
  return (
    <section
      data-testid={ATHENA.whySection}
      className="relative pt-10 md:pt-14 pb-10 md:pb-14 border-t border-[#D5D1C8]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <span className="label-mono">// WHY ATHENA</span>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl mt-4 leading-[1.04] tracking-tight text-[#0A1713]">
              Numbers behind
              <br />
              the conviction.
            </h2>
          </div>
          <p className="max-w-md text-[#3D4F46]">
            We are a research-led company. The figures below reflect
            <br />
            a culture of measured ambition — not marketing rounding.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-[#D5D1C8] border border-[#D5D1C8]">
          {METRICS.map((m, i) => (
            <motion.div
              key={m.slug}
              data-testid={ATHENA.metricItem(m.slug)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="bg-[#F8F7F4] p-8 md:p-12 flex flex-col justify-between min-h-[200px]"
            >
              <div className="font-mono text-[2rem] md:text-[2.5rem] leading-none text-[#1A382A] tracking-tight">
                {m.n}
              </div>
              <div className="mt-6 text-[#3D4F46] leading-relaxed max-w-[260px]">
                {m.l}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Why;
